import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Nav, Tab, Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import styleClasses from "./accounts.module.scss";
import UserSelections from "../../components/UserSelections/UserSelections";
import { CustomModal } from "../../components/Modal/CustomModal";
import { DeliveryAddressForm } from "../../components/Forms/DeliveryAddressForm";
import PersonalInfoTab from "../../components/Tabs/PersonalInfo";
import DeliveryAddressesTab from "../../components/Tabs/DeliveryAdress/DeliveryAddresses";
import { PersonalInfoForm } from "../../components/Forms/PersonalInfoForm";
import StoredPayments from "../../components/Tabs/StoredPayments";
import VehicleDetails from "../../components/Tabs/VehicleInfo/VehicleDetails";
import VehicleInfoForm from "../../components/Forms/VehicleInfoForm";
import ScrollspyNav from "react-scrollspy-nav";
import { Scrollbars } from "react-custom-scrollbars-2";
import * as CONSTANT from "../../../src/constants";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import useProfile from "../../react-query-hooks/useProfile";
import { useAuthState } from "../../context/UserAuthentication";
import Spinner from "../../components/Spinner/Spinner";
import { scrollToElementByRef } from "../../helpers/helperMethods";
import _debounce from "lodash/debounce";
import useOrderHistory from "../../react-query-hooks/useOrderHistory";
import usePaymentMethods from "../../react-query-hooks/usePaymentMethods";
import useFavorites from "../../react-query-hooks/useFavorites";
import { useStoreLocation } from "../../context/StoreLocation";
import DeleteAccount from "../../components/Tabs/DeactivateAccount/DeleteAccount";
import StoredGiftCards from "../../components/Tabs/GiftCard";
import useGetGiftCards from "../../react-query-hooks/useGetGiftCards";
import { FormField } from "../../components/FormFields/FormField";
import { Formik } from "formik";
import _clonedeep from "lodash.clonedeep";
import * as Yup from "yup";
import { useQueryClient } from "react-query";
import { useAppSelector } from "../../redux/store/store";
import AuthenticatedDevices from "../../components/Tabs/AuthenticatedDevices/authenticatedDevices";
import ArrowBack from "../../../src/images/arrow-back.svg";
import ErrorFallback from "../../components/ErrorFallback/ErrorFallBack";
import BottomMenu from "../home/BottomMenu";
import { TRUE } from "sass";
import useTrackBarVisibility from "../../hooks/useTrackBarVisibility";
import { useIsDesignV2 } from "../../hooks/useIsDesignV2";
import Button from "../../components/Buttons/Button";
import {
  PROFILE_SECTION_IDS,
  PULSE_VIEW_ID,
  profileSectionIdToViewId,
  profileTabToViewId,
  trackPulseView,
} from "../../analytics/pulseViewIds";
import {
  PULSE_PROFILE_CLICK_SCROLL_SUPPRESS_MS,
  PULSE_PROFILE_SCROLL_DEBOUNCE_MS,
} from "../../analytics/pulseConstants";
import {
  PULSE_PROFILE_ACTIVE_VIEW_ID_KEY,
  trackCustomerTabClick,
} from "../../analytics/pulseClickIds";

interface VehicleInfo {
  show: boolean;
  title: string;
  id: number | null;
  forOneTimeOnly?: boolean;
}

export default function ProfileDetails() {
  const [activeTabkey, setActiveTabkey] = useState(() => {
    try {
      const stored = sessionStorage.getItem("activeTab");
      return stored ? JSON.parse(stored) : "first";
    } catch {
      return "first";
    }
  });
  const queryClient = useQueryClient();
  const isCheckTrackBar = useTrackBarVisibility();

  useEffect(() => {
    sessionStorage.setItem("activeTab", JSON.stringify(activeTabkey));
  }, [activeTabkey]);

  const { authInfo } = useAuthState();
  const lastProfileViewIdRef = useRef<string | null>(null);
  /** After sidebar click, ignore scroll views until smooth-scroll finishes. */
  const profileScrollIgnoreUntilRef = useRef(0);

  const [show3, setShow3] = useState(false);
  const [vehicleInfoModal, setvehicleInfoModal] = useState<VehicleInfo>({
    show: false,
    title: "",
    id: null,
    forOneTimeOnly: false,
  });
  const { isFetching, data, error , isError , refetch} = useProfile(authInfo.userId);
  const retried = useRef(false);

  useEffect(() => {
    refetch();
  }, []);
  
  useEffect(() => {
    if (isError && !retried.current) {
      retried.current = true; 
      refetch();
    }
  }, [isError]);

  const [addressFormState, setAddressFormState] = useState<{
    show: boolean;
    title: string;
    id: number | null;
  }>({ show: false, title: "", id: null });
  const isItMobile = useCheckMobileScreen();

  // const { data: { data: placedOrders = [] } = [] } = useGetCustomerPlacedOrders(
  //   { userId: authInfo?.userId }
  // );

  // const isCheckTrackBar =
  //   placedOrders?.length && authInfo.type !== CONSTANT.GUEST_USER;
  const [cardIncrement, setcardIncrement] = useState(false);
  const [vehicleInfoForOneTime, setVehicleInfoForOneTime] = useState([]);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const vehicleEditInfoModal = (
    title?: string,
    id?: number,
    forOneTimeOnly?: boolean
  ) =>
    setvehicleInfoModal({
      show: true,
      title: title,
      id: id,
      forOneTimeOnly: forOneTimeOnly,
    });
  const closeEditInfoModal = () =>
    setvehicleInfoModal({ show: false, title: "", id: null });

  const hideAddressForm = () => {
    setAddressFormState({ show: false, title: "", id: null });
  };
  const showAddressForm = (title?: string, id?: number) => {
    setAddressFormState({ show: true, title: title, id: id });
  };

  const addVehicleInfoForOneTime = (data) => {
    setVehicleInfoForOneTime([data, ...vehicleInfoForOneTime]);
  };
  const editVehicleInfoForOneTime = (data) => {
    vehicleInfoForOneTime[data.id] = data;
  };
  const removeVehicleInfoForOneTime = (id) => {
    let vehicleInfo = vehicleInfoForOneTime.filter((item) => item.id != id);
    setVehicleInfoForOneTime([...vehicleInfo]);
  };
  useEffect(() => {
    if (cardIncrement) {
      setTimeout(function () {
        setcardIncrement(false);
      }, 1500);
    }
  }, [cardIncrement]);
  const history = useNavigate();
  const location = useLocation();
  const goToRoute = (route: string) => history(route);
  const isDesignV2 = useIsDesignV2();

  useEffect(() => {
    if (!show3) return;
    trackPulseView(PULSE_VIEW_ID.EDIT_PERSONAL_INFO_MODAL, {
      page_path: location.pathname,
    });
  }, [show3, location.pathname]);

  useEffect(() => {
    if (!addressFormState.show) return;
    trackPulseView(
      addressFormState.id
        ? PULSE_VIEW_ID.EDIT_DELIVERY_ADDRESS_MODAL
        : PULSE_VIEW_ID.ADD_DELIVERY_ADDRESS_MODAL,
      { page_path: location.pathname }
    );
  }, [addressFormState.show, addressFormState.id, location.pathname]);

  useEffect(() => {
    if (!vehicleInfoModal.show) return;
    trackPulseView(
      vehicleInfoModal.id
        ? PULSE_VIEW_ID.EDIT_VEHICLE_MODAL
        : PULSE_VIEW_ID.ADD_VEHICLE_MODAL,
      { page_path: location.pathname }
    );
  }, [vehicleInfoModal.show, vehicleInfoModal.id, location.pathname]);

  useEffect(() => {
    // var navigationSelect = document.querySelector(".select-wrapper");
    function initSelect(elem) {
      var selectHolder = elem.querySelector(".holder");
      var selectOptions = elem.querySelectorAll(".dropdownOption li");
      var dropHolder = elem.querySelector(".dropdown");
      var selectedOption = selectOptions[0];

      selectedOption.classList.add("current");

      selectHolder.addEventListener("click", function () {
        dropHolder.classList.toggle("active");
      });

      selectOptions.forEach(function (currentElement) {
        currentElement.addEventListener("click", function () {
          selectedOption.classList.remove("current");
          selectedOption = currentElement;
          currentElement.classList.add("current");
          selectHolder.innerText = currentElement.textContent;
          dropHolder.classList.toggle("active");
        });
      });
    }

    // initSelect(navigationSelect);
  }, []);
  const { locationInfo } = useStoreLocation();
  const location_id = locationInfo?.selectedStore?.id ?? "";

  const { data: paymentRecords = [], isFetching: isFetchingPaymentRecords } =
    usePaymentMethods(authInfo.userId);

  const {
    isFetching: isFetchingFavourites,
    data: favouritesData = [],
    refetch: refetchFavourites,
  } = useFavorites(authInfo.userId, authInfo.type, location_id);

  const { data: giftCardRecords = [], isFetching: isFetchingGiftCards } =
    useGetGiftCards(authInfo.userId);

  const trackProfileSectionView = (viewId: string | null) => {
    if (!viewId || lastProfileViewIdRef.current === viewId) return;
    lastProfileViewIdRef.current = viewId;
    sessionStorage.setItem(PULSE_PROFILE_ACTIVE_VIEW_ID_KEY, viewId);
    trackPulseView(viewId, { page_path: CONSTANT.ROUTE_PROFILE_DETAILS });
  };

  // Pulse mobile: Tab.Container eventKeys
  useEffect(() => {
    if (!isItMobile) return;
    trackProfileSectionView(profileTabToViewId(activeTabkey));
  }, [activeTabkey, isItMobile]);

  /**
   * Pulse desktop: match ScrollspyNav behavior (offset ~230).
   * - Click sidebar → fire destination only (suppress scroll pass-through)
   * - Manual scroll → fire only after scroll settles (debounce)
   */
  useEffect(() => {
    if (isItMobile) return;
    // Sections are not in the DOM while the spinner is up
    if (isFetching || isFetchingPaymentRecords || isFetchingGiftCards) return;

    const SCROLLSPY_OFFSET = 230;
    let scrollDebounceTimer: ReturnType<typeof setTimeout> | null = null;

    const resolveActiveSectionId = (): string | null => {
      let current: string | null = null;
      PROFILE_SECTION_IDS.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        if (el.getBoundingClientRect().top - SCROLLSPY_OFFSET <= 0) {
          current = id;
        }
      });
      return current || "Personal_Info";
    };

    const syncActiveSection = () => {
      if (Date.now() < profileScrollIgnoreUntilRef.current) return;
      trackProfileSectionView(profileSectionIdToViewId(resolveActiveSectionId()));
    };

    const onScroll = () => {
      if (Date.now() < profileScrollIgnoreUntilRef.current) return;
      if (scrollDebounceTimer != null) clearTimeout(scrollDebounceTimer);
      scrollDebounceTimer = setTimeout(() => {
        scrollDebounceTimer = null;
        syncActiveSection();
      }, PULSE_PROFILE_SCROLL_DEBOUNCE_MS);
    };

    // Land / after content mounts
    syncActiveSection();

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (scrollDebounceTimer != null) clearTimeout(scrollDebounceTimer);
    };
  }, [isItMobile, isFetching, isFetchingPaymentRecords, isFetchingGiftCards]);

  const onDesktopProfileNavClick = (sectionId: string) => {
    // Fire only the clicked tab; ignore intermediate sections during smooth scroll
    profileScrollIgnoreUntilRef.current =
      Date.now() + PULSE_PROFILE_CLICK_SCROLL_SUPPRESS_MS;
    trackCustomerTabClick(sectionId, 'desktop_section');
    trackProfileSectionView(profileSectionIdToViewId(sectionId));
  };

  let scrollToTab = "first";
  const state = location.state as { scrollTo: string };
  if (
    state?.scrollTo === CONSTANT.SCROLL_TO_PROFILE_FAV_ITEMS &&
    isItMobile &&
    !isFetching &&
    !isFetchingPaymentRecords &&
    !isFetchingFavourites
  ) {
    scrollToTab = CONSTANT.SCROLL_TO_PROFILE_FAV_ITEMS;
    delete state.scrollTo;
    history(location.pathname + location.search, {
      replace: true,
      state: state,
    })
  }
  const scrollToFavItemsDivRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    refetchFavourites();
  }, [location_id]);

  useEffect(() => {
    if (state?.scrollTo === CONSTANT.SCROLL_TO_PROFILE_FAV_ITEMS) {
      scrollToTab = CONSTANT.SCROLL_TO_PROFILE_FAV_ITEMS;
      if (
        !isItMobile &&
        !isFetching &&
        !isFetchingPaymentRecords &&
        !isFetchingFavourites
      ) {
        setTimeout(() => {
          scrollToElementByRef(scrollToFavItemsDivRef);
        }, 250);
        delete state.scrollTo;
        history(location.pathname + location.search, {
          replace: true,
          state: state,
        })
      }
    }
  }, [
    isFetching,
    isFetchingPaymentRecords,
    isFetchingFavourites,
  ]);

  if (
    isFetching ||
    isFetchingPaymentRecords ||
    isFetchingFavourites
  )
  return <><Spinner inlineStyle={isDesignV2 ? {height: "calc(100vh - 144px)", top: "76px"} : {}} />{isDesignV2 && <BottomMenu/>}</>
  
  return (
    <div className={`${isDesignV2 ? "pb-3 mb-5" : ""}`}>
      <div className="container-fluid">
        <button
          onClick={(event: any) => {
            event.preventDefault();
            goToRoute(CONSTANT.ROUTE_MENU);
          }}
          className="btn btn-custom f-s14  ms-3 p-0 mt-4 align-items-center gap-2 d-none d-md-flex position-fixed"
        >
          <img
            src={ArrowBack}
            alt="arrow back"
          />
          Back
        </button>
      </div>
      <div className={`${styleClasses.profile_wrapper} profile-wrapper`}>
        <div
          className={`${styleClasses.profile_tabs_wrapper} text-center pt-md-2 pb-4 py-md-4 custom_w px-3`}
        >
          {isItMobile && (
            <div
              className={`${styleClasses.nav} flex-wrap d-flex select-wrapper d-md-none ${
                isCheckTrackBar && "cz-pt-45"
              }`}
            >
              <Tab.Container
                defaultActiveKey={activeTabkey}
                activeKey={activeTabkey}
                onSelect={(k) => {
                  trackCustomerTabClick(k, 'mobile_tab');
                  setActiveTabkey(k);
                }}
              >
                <Nav variant="pills">
                  <Scrollbars
                    className={`${styleClasses.menu_items_scrollbar} ${styleClasses.profile_items_scrollbar}`}
                    renderThumbHorizontal={(props) => (
                      <div
                        {...props}
                        className={styleClasses.Scrollbar_thumb}
                      />
                    )}
                    renderView={(props) => (
                      <div
                        {...props}
                        className={`${styleClasses.Scrollbar_view} Scrollbar_view`}
                      />
                    )}
                  >
                    <Nav.Item className={`${styleClasses.nav_items}`}>
                      <Nav.Link eventKey="first">Personal Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className={`${styleClasses.nav_items}`}>
                      <Nav.Link eventKey="second">Payments</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className={`${styleClasses.nav_items}`}>
                      <Nav.Link eventKey="third">Gift cards</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className={`${styleClasses.nav_items}`}>
                      <Nav.Link eventKey="fourth">Delivery Addresses</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className={`${styleClasses.nav_items} mb-0`}>
                      <Nav.Link eventKey="eight">Your Devices</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className={`${styleClasses.nav_items} mb-0`}>
                      <Nav.Link eventKey="nine">Delete Account</Nav.Link>
                    </Nav.Item>
                  </Scrollbars>
                </Nav>
                <Tab.Content className="w-100">
                  <Tab.Pane eventKey="first" title="Profile Info">
                    <button
                      onClick={(event: any) => {
                        event.preventDefault();
                        goToRoute(CONSTANT.ROUTE_MENU);
                      }}
                      className="btn btn-custom f-s16  p-0 my-3 align-items-center gap-2  d-flex"
                    >
                      <img
                        src={ArrowBack}
                        alt="arrow back"
                      />
                      Back
                    </button>
                    {
                      data ?
                      <PersonalInfoTab
                        data={data}
                        eventKey={"first"}
                        showEditInfoModal={handleShow3}
                      /> : 
                      <ErrorFallback sectionName="Profile & Preferences" />  
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="second" title="Payment">
                    <button
                      onClick={(event: any) => {
                        event.preventDefault();
                        goToRoute(CONSTANT.ROUTE_MENU);
                      }}
                      className="btn btn-custom f-s16  p-0 my-3 align-items-center gap-2  d-flex"
                    >
                      <img
                        src={ArrowBack}
                        alt="arrow back"
                      />
                      Back
                    </button>
                    {
                      data && paymentRecords ?
                      <StoredPayments
                        data={data}
                        paymentRecords={paymentRecords}
                      /> : 
                      <ErrorFallback sectionName="Payment" />  
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="third" title="Gift Cards">
                    <button
                      onClick={(event: any) => {
                        event.preventDefault();
                        goToRoute(CONSTANT.ROUTE_MENU);
                      }}
                      className="btn btn-custom f-s16  p-0 my-3 align-items-center gap-2  d-flex"
                    >
                      <img
                        src={ArrowBack}
                        alt="arrow back"
                      />
                      Back
                    </button>
                    {
                      giftCardRecords ?
                      <StoredGiftCards giftCardRecords={giftCardRecords} />
                      : <ErrorFallback sectionName="Gift Cards" />  
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="fourth" title="Delivery Address">
                    <button
                      onClick={(event: any) => {
                        event.preventDefault();
                        goToRoute(CONSTANT.ROUTE_MENU);
                      }}
                      className="btn btn-custom f-s16  p-0 my-3 align-items-center gap-2  d-flex"
                    >
                      <img
                        src={ArrowBack}
                        alt="arrow back"
                      />
                      Back
                    </button>
                    {
                      data ?
                      <DeliveryAddressesTab
                        data={data}
                        eventKey={"fourth"}
                        showModal={showAddressForm}
                      /> : 
                      <ErrorFallback sectionName="Delivery Address" />  
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="eight" title="Deactivate Account">
                    <AuthenticatedDevices />
                  </Tab.Pane>
                  <Tab.Pane eventKey="nine" title="Deactivate Account">
                    <button
                      onClick={(event: any) => {
                        event.preventDefault();
                        goToRoute(CONSTANT.ROUTE_MENU);
                      }}
                      className="btn btn-custom f-s16  p-0 my-3 align-items-center gap-2  d-flex"
                    >
                      <img
                        src={ArrowBack}
                        alt="arrow back"
                      />
                      Back
                    </button>
                    <DeleteAccount />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          )}
          {!isDesignV2 && <UserSelections scrollToDivRef={scrollToFavItemsDivRef} />}
          {!isItMobile && (
            <div
              className={`${styleClasses.profile_tabs_wrapper} text-center pt-2 pb-4 py-md-4 custom_w px-3 d-none d-md-block`}
            >
              <Row className="mt-md-2">
                <Col md={3} className="position-relative">
                  <ScrollspyNav
                    scrollTargetIds={[
                      "Personal_Info",
                      "Payment",
                      "Gift_Cards",
                      "Delivery_Address",
                      "Your_Devices",
                      "Delete_Account",
                    ]}
                    scrollDuration="500"
                    activeNavClass="is-active"
                    offset={-230}
                    headerBackground="true"
                  >
                    <Nav
                      variant="pills"
                      className={`${styleClasses.nav} flex-column d-none d-md-flex`}
                    >
                      <Nav.Item>
                        <Nav.Link
                          href="#Personal_Info"
                          className={` is-active`}
                          onClick={() => onDesktopProfileNavClick("Personal_Info")}
                        >
                          Profile Info
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          href="#Payment"
                          onClick={() => onDesktopProfileNavClick("Payment")}
                        >
                          Payment
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          href="#Gift_Cards"
                          onClick={() => onDesktopProfileNavClick("Gift_Cards")}
                        >
                          Gift Cards
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          href="#Delivery_Address"
                          onClick={() =>
                            onDesktopProfileNavClick("Delivery_Address")
                          }
                        >
                          Delivery Address
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          href="#Your_Devices"
                          onClick={() =>
                            onDesktopProfileNavClick("Your_Devices")
                          }
                        >
                          Your Devices
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          href="#Delete_Account"
                          onClick={() =>
                            onDesktopProfileNavClick("Delete_Account")
                          }
                        >
                          Delete Account
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </ScrollspyNav>
                </Col>
                <Col md={9} className={styleClasses.scroll_spacing}>
                  <div>
                    <div id="Personal_Info">
                      {
                        data ?
                          <PersonalInfoTab
                            data={data}
                            eventKey={"first"}
                            showEditInfoModal={handleShow3}
                          /> : 
                          <ErrorFallback sectionName="Profile & Preferences" />  
                      }
                    </div>
                    <div id="Payment">
                      {
                        data && paymentRecords ?
                        <StoredPayments
                          data={data}
                          paymentRecords={paymentRecords}
                        /> : 
                        <ErrorFallback sectionName="Payment" />  
                      }
                    </div>
                    <div id="Gift_Cards">
                      {
                        giftCardRecords ?
                        <StoredGiftCards giftCardRecords={giftCardRecords} />
                        : <ErrorFallback sectionName="Gift Cards" />  
                      }
                    </div>
                    <div id="Delivery_Address">
                      {
                        data ?
                        <DeliveryAddressesTab
                          data={data}
                          eventKey={"third"}
                          showModal={showAddressForm}
                        /> : 
                        <ErrorFallback sectionName="Delivery Address" />  
                      }
                    </div>
                    <div id="Your_Devices">
                      <AuthenticatedDevices/>
                    </div>
                    <div id="Delete_Account" ref={scrollToFavItemsDivRef}>
                      <DeleteAccount />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
        {isDesignV2 && (
          <div className="d-md-none">
            <BottomMenu/>
          </div>
        )}
        {/* Edit Information Modal */}
        <CustomModal
          showModal={show3}
          closeModal={handleClose3}
          title={" EDIT INFORMATION"}
        >
          <PersonalInfoForm closeModal={handleClose3} />
        </CustomModal>
        {/* New Payment Method Modal */}

        {/* Add/Edit Delivery Address Modal */}
        <CustomModal
          showModal={addressFormState.show}
          closeModal={hideAddressForm}
          title={addressFormState.title}
        >
          <DeliveryAddressForm
            closeModal={hideAddressForm}
            addressId={addressFormState.id}
          />
        </CustomModal>
        {/* Add/Edit Delivery Address Modal */}
        <CustomModal
          showModal={vehicleInfoModal.show}
          closeModal={closeEditInfoModal}
          title={vehicleInfoModal.title}
        >
          <VehicleInfoForm
            closeModal={closeEditInfoModal}
            vehicleId={vehicleInfoModal.id}
            addVehicleInfoForOneTime={addVehicleInfoForOneTime}
            vehicleInfoForOneTime={vehicleInfoForOneTime}
            editVehicleInfoForOneTime={editVehicleInfoForOneTime}
            vehicleInfo={vehicleInfoModal}
          />
        </CustomModal>
      </div>
    </div>
  );
}
const OrderFavoriteSchema = Yup.object().shape({
  orderFavouriteLabel: Yup.string().trim().required("Must Enter Name").max(30,"Length Should Be Less Than 30 Character"),

});

export const LabelFavoriteOrder = ({
  showAddLabelModal,
  hideLabelModal,
  onAddLabelOrderHandler,
  isDesignV2 = null
}) => {
  const location = useLocation();

  useEffect(() => {
    if (!showAddLabelModal) return;
    trackPulseView(PULSE_VIEW_ID.NAME_FAVORITE_ORDER_MODAL, {
      page_path: location.pathname,
    });
  }, [showAddLabelModal, location.pathname]);

  const initialFormState = {
    orderFavouriteLabel: "",
  };
  return (
    <Modal
      show={showAddLabelModal}
      onHide={hideLabelModal}
      centered
      className={`theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-8  ${isDesignV2 ? 'favorite-order-modal-mobile-designv2' : ''}`}
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 blue-icon"
          onClick={hideLabelModal}
        >
          Close
        </button>
        { isDesignV2 &&     <h6 className={`font-Cls ls-normal text-capitalize f-s20 f-w3 mb-0`}>
          Name your favorite order 
        </h6>}
      </Modal.Header>
      <Modal.Body className="text-center py-5 px-0 px-md-3">
{  !isDesignV2 &&     <h6 className={`font-Cls ls-normal mb-sm-3 mb-3 text-capitalize f-s22`}>
          Name your favorite order 
        </h6>}
        <div className="new_form_design">
        <Formik
          initialValues={initialFormState}
          validationSchema={OrderFavoriteSchema}
          onSubmit={onAddLabelOrderHandler}
          validateOnMount
        >
          {({ errors, touched, handleChange, isSubmitting, handleSubmit,values }) => {
            return (
              <>
                <FormField
                  labelText={""}
                  name="orderFavouriteLabel"
                  type="text"
                  onChange={(e)=> {
                    e.target.value=e.target.value.trimStart()
                    handleChange(e)}}
                  errors={errors}
                  touched={touched}
                  maxLength={30}
                  placeholder="Enter Name"
                />
                <Button
                    type="button"
                    className={`btn btn-large mt-4 mb-3 d-block ${isDesignV2 ? 'w-100 save-fav-order-mobile-designv2' : 'mx-auto'}`}
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    disabled={ errors?.orderFavouriteLabel ? true : false}
                    id={"save-favorite-order-button"}
                  >
                    Save
                  </Button>
              </>
            );
          }}
        </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const AddToFavoriteModalConfirmation = ({
  showAddAndRemoveModal,
  hideAddAndRemoveModal,
  id,
  name,
  onRemoveClickHandler,
  isDesignV2 = null
}) => {
  return (
    <Modal
      show={showAddAndRemoveModal}
      onHide={hideAddAndRemoveModal}
      centered
      className={`theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-8 ${isDesignV2 ? 'fav-delete-order-mobile-designv2' : ''}`}
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 blue-icon"
          onClick={hideAddAndRemoveModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body className="text-center py-5 px-0 px-md-3">
        <h6 className={`font-Cls f-s22 text-capitalize ${isDesignV2 ? 'f-w4 lh-normal mb-3' : 'ls-normal mb-sm-4 mb-3'}`}>
          Are you sure?
        </h6>
        <p className={`f-s14 ${isDesignV2 ? 'mb-4 lh-ls ls-05 f-w4 font-Visby-cf' : 'mb-4'}`}>
          Your favorite order will be deleted
          {/* <br />
          this selected item? */}
        </p>
        <div className="text-center">
          <button
            type="button"
            className={`btn btn-large d-block ${isDesignV2 ? 'w-100 mb-4 py-2 lh-22'  : 'mx-auto mb-sm-4 mb-3'}`}
            onClick={onRemoveClickHandler}
          >
            Yes
          </button>
          <button
            type="button"
            className={`btn btn-custom clr-dark-blue p-0 ls-05 ${isDesignV2 ? 'font-Visby-cf f-w6 f-s15' : 'f-s16 font-Vcf'}`}
            onClick={hideAddAndRemoveModal}
          >
            No, Keep The Order
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
